import React, { useEffect, useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import { Link } from 'react-router-dom';
import "./scrollhouse.css";

function ScrollHousing() {

    const [houseScroll, setHouseScroll]                             = useState([]);

    const quantity = 7;

    useEffect(() => {
        shortScrollListing();
    },[])

    const shortScrollListing = async () => {
      try{
        const short = await axios.get(CONSTANTS.API_CUST +"house/random/decade/");
        console.log(short);
        setHouseScroll(short.data)
      }catch(err){
        console.log(err);
      }
    }

  return (
    <div className="ratio-displya">
        {
            houseScroll &&
            houseScroll.length > 0 && (
                <div className="slider-container" reverse="true"  style={{
                    '--width': '200px',    
                    '--height': '200px',    
                    '--quantity': houseScroll.length    
                }}>
                    <div className="list-elements">
                        
                        {
                            houseScroll.map((image, index) => (
                                <div className="item" style={{ '--position': index + 1 }} key={index}>
                                     <Link 
                                        to={"/person/" + image.id}
                                        className="link-scroll">
                                            <img src={image.featuredImage.url} alt={`Slide ${index + 1} Bantus - ${image.title}`} />
                                    </Link>
                                </div>
                            ))
                        }
                    </div>
                </div>
            )
        }
        
    </div>
  )
}

export default ScrollHousing